import { MdOutlineAssignment, MdOutlineBarChart } from 'react-icons/md'
import { MenuItems } from '@/Core/Contracts/UI/Menu'

export const Menu: MenuItems = [
    'Index.Index',
    'Transport.Driver',
    'Transport.Vehicle',
    'Transport.TypicalRoute',
    'Request',
    // «Задачі» — підменю з двома сторінками контейнера Assignment. Ключі підпунктів —
    // ключі сторінок (pageConfig.key): за ними ядро знаходить маршрут для переходу
    // й підсвічує пункт і розкриває батьківський (findKeyPath), а FilterMenuByAccessTask
    // ховає їх без read_collection на ExecutorAssignment (разом з порожнім батьком).
    // Підписи короткі, бо повні «Задачі з заявками» дублювали б назву батька.
    {
        key: 'assignments',
        label: 'Задачі',
        icon: <MdOutlineAssignment />,
        children: [
            { key: 'Assignment.WithRequests', label: 'З заявками' },
            { key: 'Assignment.WithoutRequests', label: 'Без заявок' },
        ],
    },
    // «Зміни» — зміни водіїв (водій + ТЗ на дату); видимість — за read_collection на Shift
    'Shift.Shift',
    // «Звіти» — підменю, як «Задачі»: кожен звіт — окрема сторінка контейнера Report
    {
        key: 'reports',
        label: 'Звіти',
        icon: <MdOutlineBarChart />,
        children: [
            { key: 'Report.DispatcherRating', label: 'Рейтинг диспетчера' },
            { key: 'Report.Completion', label: 'Виконання задач' },
            { key: 'Report.MileageControl', label: 'Контроль пробігу' },
        ],
    },
    {
        key: 'settings',
        label: 'Налаштування',
        type: 'group',
        children: [
            'Setting.User',
            // 'Setting.Department',
            'Setting.Index',
            'Setting.SystemEvents',
            'Setting.ManualToken',
            'Setting.ErpExchange',
            'Setting.PortalSettings',
        ],
    },
]
